import { capitalize } from "lodash";

/**
 * Format a fraud category for display. Most are a plain capitalization; the ones
 * that are not are listed, so the exceptions are visible in one place.
 */
const LABELS: Record<string, string> = {
  // Not a persisted fraud category — the document-verification card that sits in
  // the same strip.
  iddocuments: "ID Documents",
  // Not a persisted fraud category either — the sanctions screen run inside the
  // fraud evaluation. Called OFAC to keep it apart from the Watchlist tab, which
  // is a different product.
  watchlist: "OFAC",
  // Retired by this release — synthetic and kyc fold into `identity`. Kept for
  // the deploy window: this app can ship before the API does, and the pre-fold
  // API still emits `kyc`, which capitalize() renders as "Kyc". The ORDERING
  // half of the same skew is handled in FraudCategoryDisplay (unknown categories
  // sort last); this is the label half.
  kyc: "KYC",
};

export const formatFraudCategory = (category: string): string => {
  const key = category.toLowerCase();
  // Own keys only: a category named "constructor" would otherwise resolve to
  // Object's constructor function rather than fall through to capitalize().
  return Object.prototype.hasOwnProperty.call(LABELS, key)
    ? LABELS[key]
    : capitalize(category);
};
